module.exports = __webpack_public_path__ + "static/media/store4.b5ef44d9.jpg";